import {CustomerBankAccount} from '../../../api/customerBankAccounts/CustomerBankAccount.ts';
import {MoneyLabel} from '../../general/MoneyLabel.tsx';
import {CreditCardSchemeLogo, detectSchemeFromCreditCardNumber, isRecognisedCreditCardPrefix} from '../CreditCard';
import {appearance as lightSurfaceLogoAppearance} from '../CreditCard/skins/brand/appearance.ts';
import {DEFAULT_SCHEME_LOGO_APPEARANCE} from '../CreditCard/skins/defaultSchemeLogoAppearance.ts';
import {balanceTextSizeClass} from './balanceTextSize.ts';
import {CardFront} from './CardFront.tsx';
import {creditCardTitle, paletteSeed, UNBRANDED_CREDIT_CARD_TITLE} from './cardIdentity.ts';
import {MaskedCardDigits} from './MaskedCardDigits.tsx';
import {bankDisplayName} from './knownBanks.ts';
import {getBankCardSkin} from './skins';

function NoIssuerBrand() {
    return null;
}

interface Props {
    customerBankAccount: CustomerBankAccount;
}

export function CreditCardAccountCard({customerBankAccount: account}: Props) {
    const prefix = account.creditCardNumberPrefix ?? '';
    const suffix = account.creditCardNumberSuffix ?? '';
    const scheme = detectSchemeFromCreditCardNumber(prefix);
    const hasIssuer = account.institutionName.trim() !== '';
    const issuerName = bankDisplayName(account.institutionName);
    const issuerSkin = getBankCardSkin(account.institutionName, paletteSeed(account.institutionName, issuerName, account.id));
    const skin = hasIssuer ? issuerSkin : {...issuerSkin, Brand: NoIssuerBrand};
    const isNetworkKnown = isRecognisedCreditCardPrefix(prefix);
    const hasCardNumber = prefix !== '' || suffix !== '';
    const name = creditCardTitle({
        issuerName,
        hasIssuer,
        networkName: account.displayInstitutionName(),
        isNetworkKnown,
    });
    const logoAppearance = skin.surfaceTone === 'light' ? lightSurfaceLogoAppearance : DEFAULT_SCHEME_LOGO_APPEARANCE;

    return (
        <CardFront
            skin={skin}
            brandProps={{logoUrl: account.logoUrl, institutionDisplayName: name}}
            fadeTextOnHover={false}
            hideDetails={false}
            ariaLabel={name === UNBRANDED_CREDIT_CARD_TITLE ? name : `Creditcard ${name}`}
            isMuted={false}
            balanceLabel="Saldo"
            balance={<MoneyLabel value={account.balance / 100} currency={account.currency || 'EUR'} showCurrency />}
            balanceSizeClass={balanceTextSizeClass(account.balance)}
            holderName={account.ownerName}
            accountLine={hasCardNumber ? <MaskedCardDigits scheme={scheme} prefix={prefix} suffix={suffix} /> : ''}
            networkMark={isNetworkKnown && <CreditCardSchemeLogo scheme={scheme} appearance={logoAppearance} />}
            footer={null}
            overlay={null}
        />
    );
}
